<div class="page">
  <div class="container px-5">
    <div class="row">
      <div class="col-12 page-title">
        <h1>{{title}}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div *ngFor="let educ of education">
          <h5>{{ educ.titulo }}</h5>
          <p class="my-0">{{ educ.institucion }}</p>
          <p><small class="text-muted">{{ educ.fechaFin | date:"MMM-y" }}</small></p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 page-title">
        <h3 class="mt-3">Certifications</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4" *ngFor="let cert of sixLastCertifications">
        <app-certification [cert]="cert"></app-certification>
      </div>
      <div *ngIf="!showAllCerts" class="col-12 view-all-cert-btn">
        <a (click)="viewAllCerts()">
          <h4>{{viewAllCertsBtn}}</h4>
        </a>
      </div>
    </div>
    <div class="row" *ngIf="showAllCerts">
      <div class="col-12 col-md-4" *ngFor="let cert of certifications">
        <app-certification [cert]="cert"></app-certification>
      </div>
    </div>
  </div>
</div>
